import { render, staticRenderFns } from "./MedicalCompanionFilter.vue?vue&type=template&id=27c464ee&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c464ee",
  null
  
)

export default component.exports